//
//
//
//
//
//
//
//
//
//
//
//

import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { mapGetters, mapActions } from 'vuex'
import RbAfterpayPanel from '@/elements/pay-over-time/afterpay/rb-afterpay-panel.vue'
import RbAfterpayModal from '@/elements/pay-over-time/afterpay/rb-afterpay-modal.vue'
import RbPanel from '@/elements/panel/rb-panel.vue'

import {
  ACTION_CLOSE_AFTERPAY_MODAL_OR_PANEL,
  ACTION_OPEN_AFTERPAY_MODAL_OR_PANEL,
} from '@/scripts/store/actions'

export default {
  name: 'rb-afterpay-panel-and-modal',
  components: {
    RbAfterpayPanel,
    RbAfterpayModal,
    RbPanel,
  },
  props: {
    prices: {
      type: Object,
      default: () => ({
        discountedPrice: undefined,
        listPrice: '',
        promo: undefined,
        priceFormat: '',
        currencySymbol: '',
      }),
    },
  },
  computed: {
    ...mapGetters(['afterpayIsVisible']),
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
  },
  mounted() {
    window.externalInvocationMethodMapping.showAfterpayModal = () => {
      this.openAfterpay()
    }
  },
  methods: {
    ...mapActions({
      openAfterpay: ACTION_OPEN_AFTERPAY_MODAL_OR_PANEL,
      closeAfterpay: ACTION_CLOSE_AFTERPAY_MODAL_OR_PANEL,
    }),
  },
}
